function tokenizarRuta(ruta) {
  const tokens = []
  let actual = ''
  let i = 0

  const pushActual = () => {
    if (actual) {
      tokens.push({ tipo: 'key', valor: actual })
      actual = ''
    }
  }

  while (i < ruta.length) {
    const c = ruta[i]

    if (c === '.') {
      pushActual()
      i++
      continue
    }

    if (c === '[') {
      pushActual()
      i++
      let contenido = ''
      let enComillas = false
      let comilla = ''
      let escape = false

      while (i < ruta.length) {
        const ch = ruta[i]
        if (escape) {
          contenido += ch
          escape = false
          i++
          continue
        }
        if (enComillas) {
          if (ch === '\\') {
            escape = true
            i++
            continue
          }
          if (ch === comilla) {
            enComillas = false
            i++
            continue
          }
          contenido += ch
          i++
          continue
        }
        if (ch === '"' || ch === "'") {
          enComillas = true
          comilla = ch
          i++
          continue
        }
        if (ch === ']') {
          i++
          break
        }
        contenido += ch
        i++
      }

      const contenidoTrim = contenido.trim()
      if (contenidoTrim === '*') {
        tokens.push({ tipo: 'wildcard' })
      } else if (/^\d+$/.test(contenidoTrim)) {
        tokens.push({ tipo: 'index', valor: Number(contenidoTrim) })
      } else if (contenidoTrim) {
        tokens.push({ tipo: 'key', valor: contenidoTrim })
      }
      continue
    }

    actual += c
    i++
  }

  pushActual()
  return tokens
}

function flattenOneLevel(arr) {
  const out = []
  for (const item of arr) {
    if (Array.isArray(item)) out.push(...item)
    else out.push(item)
  }
  return out
}

export function resolverValor(estructura, ruta) {
  if (!ruta) return ''
  const tokens = tokenizarRuta(ruta)

  function resolver(actual, idx) {
    if (idx >= tokens.length) return actual
    const token = tokens[idx]

    if (token.tipo === 'key') {
      if (actual == null || typeof actual !== 'object') return ''
      return resolver(actual[token.valor], idx + 1)
    }

    if (token.tipo === 'index') {
      if (!Array.isArray(actual)) return ''
      return resolver(actual[token.valor], idx + 1)
    }

    if (token.tipo === 'wildcard') {
      if (!Array.isArray(actual)) return ''
      const resultados = actual.map((item) => resolver(item, idx + 1))
      return flattenOneLevel(resultados)
    }

    return ''
  }

  const valor = resolver(estructura, 0)
  return valor ?? ''
}
